import { useEffect, useState } from "react";
import { Menu, X, Instagram } from "lucide-react";

const NAV = [
  { href: "#arbeiten", label: "Arbeiten" },
  { href: "#motive", label: "Verfügbare Motive" },
  { href: "#ablauf", label: "Ablauf" },
  { href: "#rene", label: "René" },
  { href: "#faq", label: "FAQ" },
];

export const Header = ({ instagram, onePage = true }) => {
  const [open, setOpen] = useState(false);
  const [solid, setSolid] = useState(false);

  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const prefix = onePage ? "" : "/";

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 border-b transition-colors duration-200 ${
        solid ? "border-paper-line bg-paper/95 backdrop-blur-md" : "border-transparent bg-paper/70 backdrop-blur-sm"
      }`}
    >
      <div className="ap-container flex h-[72px] items-center justify-between gap-4">
        <a
          href="/"
          data-testid="logo-link"
          aria-label="ArtPart Startseite neu laden"
          className="font-display text-2xl font-black uppercase tracking-[0.14em] text-ink"
        >
          Art<span className="text-signal">Part</span>
        </a>

        <nav className="hidden items-center gap-7 lg:flex" aria-label="Hauptnavigation">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={prefix + n.href}
              data-testid={`nav-${n.href.slice(1)}`}
              className="font-mono text-[11px] uppercase tracking-[0.18em] text-charcoal transition-colors duration-200 hover:text-signal"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={instagram}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="ArtPart auf Instagram"
            data-testid="header-instagram"
            className="hidden h-11 w-11 items-center justify-center border border-paper-line text-ink transition-colors duration-200 hover:border-signal hover:text-signal sm:flex"
          >
            <Instagram size={18} />
          </a>
          <a href={prefix + "#anfrage"} data-testid="header-cta" className="ap-btn-solid hidden sm:inline-flex">
            Projekt anfragen
          </a>
          <button
            type="button"
            aria-label={open ? "Menü schließen" : "Menü öffnen"}
            aria-expanded={open}
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="flex h-11 w-11 items-center justify-center border border-paper-line text-ink lg:hidden"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="border-t border-paper-line bg-paper lg:hidden">
          <nav className="ap-container flex flex-col py-4" aria-label="Mobile Navigation">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={prefix + n.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${n.href.slice(1)}`}
                className="border-b border-paper-line py-4 font-display text-lg font-bold uppercase tracking-wide text-ink"
              >
                {n.label}
              </a>
            ))}
            <a
              href={prefix + "#anfrage"}
              onClick={() => setOpen(false)}
              data-testid="mobile-cta"
              className="ap-btn-solid mt-5"
            >
              Projekt anfragen
            </a>
            <a
              href={instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="ap-btn-ghost mt-3"
              data-testid="mobile-instagram"
            >
              <Instagram size={16} /> Instagram
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};
